module.exports = __webpack_public_path__ + "img/20180803-methow-valley-00010.0ec15b50.jpg";